export class MessageManagerInMemory {
  constructor() {
    this.listeners = {};
    this.lastType = undefined;
    this.lastContent = undefined;
  }

  sendMessage(type, content) {
    this.receiveMessage(type, content);
  }

  receiveMessage(type, content) {
    try {
      this.listeners[type](content);
    } catch (e) {
      console.log('event listener', type, e);
    }
  }

  addListener(type, listener) {
    this.listeners[type] = listener;
  }

  deleteListener(type) {
    delete this.listeners[type];
  }
}
